



import Vue from 'vue';
import Component from 'vue-class-component';
import {
	newPasswordRules, confirmPasswordRules, CodeValidation, requiredOnlyValidation,
} from '@kasasa/kloans-common-ui/dist/validations';
import { postResetPassword } from '@kasasa/kloans-common-ui/dist/consumer-app/services/kloans-authentication';

@Component({
	validations: {
		username: requiredOnlyValidation.validations,
		code: CodeValidation.validations(6),
		password: newPasswordRules.validations,
		password1: confirmPasswordRules.validations,
	},
})
export default class ResetPassword extends Vue {
	username = '';

	code = '';

	password = '';

	password1 = '';

	resetBtn = true;

	beforeMount() {
		const username: string | null = sessionStorage.getItem('username');
		if (username) {
			this.username = username;
		}
	}

	get usernameErrors() {
		return requiredOnlyValidation.errors(this, 'username');
	}

	get passwordErrors() {
		return newPasswordRules.errors(this);
	}

	get passwordConfirmErrors() {
		return confirmPasswordRules.errors(this, 'password1', 'password');
	}

	get codeErrors() {
		return CodeValidation.errors(this, 'code', '6');
	}

	async resetPassword() {
		this.$v.$touch();
		if (!this.$v.$invalid) {
			this.$store.dispatch('clearError');
			this.resetBtn = false;
			try {
				await postResetPassword({
					username: this.username,
					// eslint-disable-next-line @typescript-eslint/camelcase
					confirmation_code: this.code,
					password: this.password,
				});
				sessionStorage.removeItem('username');
				this.$router.push({ name: 'passwordReset' });
			} catch (error) {
				let message = 'An unknown error has occurred.';
				if (error.response.status === 400 || error.response.status === 422) {
					message = 'Invalid username or security code. Your password has not been changed.';
				}
				this.$store.commit('showError', message);
				this.resetBtn = true;
			}
		}
	}
}
